import React from 'react'
import { Link } from "react-router-dom"
import services_info from "../Data/about_services"

const ServicesBlock = () => {
  return (
    <>
        <div className="container services-container">
            <h3 className="section-subtitle">AutoInsure</h3>
            <h1 className="section-title">Our Services</h1>
            <p className="section-caption services-caption">Here are some of the services we provide:</p>
            <div className="services-box">
                {services_info.map((i) => {
                    return (
                        <div key={i.id} id={i.id} className="service-card">
                            <span className="service-card-icon">{i.icon}</span>
                            <h1 className="service-card-title">{i.title}</h1>
                            <p className="service-card-description">{i.subtitle}</p>
                            <button className="btn btn-lg btn-light read-more">
                                <Link to={i.link}>
                                    {i.button_text}
                                </Link>
                            </button>
                        </div>
                    )
                })}
            </div>
        </div>
    </>
  )
}

export default ServicesBlock
